import classNames from 'classnames'
import React from 'react'

export interface SpinnerProps {
  size?: 'small' | 'large'
  sizeTb?: 'small' | 'large'
  sizeSm?: 'small' | 'large'
  sizeLg?: 'small' | 'large'
}

export const Spinner = ({ size = 'small', sizeTb, sizeSm, sizeLg }: SpinnerProps) => (
  <div
    className={classNames(
      {
        'w-[126px] h-[126px] [--spinner-width:14px]': size === 'small',
        'w-[318px] h-[318px] [--spinner-width:28px]': size === 'large',
        'tb:w-[126px] tb:h-[126px] tb:[--spinner-width:14px]': sizeTb === 'small',
        'tb:w-[318px] tb:h-[318px] tb:[--spinner-width:28px]': sizeTb === 'large',
        'sm:w-[126px] sm:h-[126px] sm:[--spinner-width:14px]': sizeSm === 'small',
        'sm:w-[318px] sm:h-[318px] sm:[--spinner-width:28px]': sizeSm === 'large',
        'lg:w-[126px] lg:h-[126px] lg:[--spinner-width:14px]': sizeLg === 'small',
        'lg:w-[318px] lg:h-[318px] lg:[--spinner-width:28px]': sizeLg === 'large',
      },
      'rounded-full animate-spin',
      '[background-image:conic-gradient(transparent_72deg,#fff_360deg)]',
      '[mask:radial-gradient(farthest-side,transparent_calc(100%-var(--spinner-width)),#fff_0)]'
    )}
  ></div>
)
